import { queryStringToParameters } from '../urlUtils';

export function getActiveExperimentFromQueryParameter(url = window.location) {
  const { utm_expid: expid } = queryStringToParameters(url.search);
  if (!expid) return null;

  const expidParts = expid.split('.');
  return {
    experimentId: expidParts[1],
    variant: expidParts[2],
  };
}
